import { useLocation, useNavigate } from "@solidjs/router";
import { createSignal } from "solid-js";
import { useAuth } from "../auth/AuthContext.tsx";
import { ErrorBanner } from "../components/ErrorBanner.tsx";

export function Login() {
  const { client, setSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [totpCode, setTotpCode] = createSignal("");
  const [error, setError] = createSignal<unknown | null>(null);
  const [busy, setBusy] = createSignal(false);

  async function onSubmit(e: Event) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await client.login({
        email: email(),
        password: password(),
        totpCode: totpCode(),
      });
      setSession({
        jwt: res.jwt,
        accountId: res.accountId,
        sessionId: res.sessionId,
        expiresAt: res.expiresAt,
      });
      const from = (location.state as { from?: string } | null)?.from ?? "/";
      navigate(from, { replace: true });
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="auth-shell">
      <form onSubmit={onSubmit} class="card auth-card">
        <h1>Platform dashboard</h1>
        <p class="muted">Sign in with your account email, password, and authenticator code.</p>
        <ErrorBanner error={error()} />
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          autocomplete="email"
          value={email()}
          onInput={(e) => setEmail(e.currentTarget.value)}
          required
        />
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          autocomplete="current-password"
          value={password()}
          onInput={(e) => setPassword(e.currentTarget.value)}
          required
        />
        <label for="totp">6-digit code</label>
        <input
          id="totp"
          inputmode="numeric"
          pattern="[0-9]{6}"
          autocomplete="one-time-code"
          value={totpCode()}
          onInput={(e) => setTotpCode(e.currentTarget.value.replace(/\D/g, "").slice(0, 6))}
          required
        />
        <button type="submit" class="primary auth-submit" disabled={busy()}>
          {busy() ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
